import styled from 'styled-components';

export const IframeWrapper = styled.div`
  width: 100%;
  min-height: 600px;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  background-color: white;

  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 500px;
    border: none;
    display: block;
  }
`;
